export const CUSTOM_OPTION_VALUE = "-custom-";

export const DEPLOYMENT_TYPES = [
  { value: "ON-PERMIS", label: "On-premise" },
  { value: "CLOUD", label: "Cloud" },
  { value: "OTHER", label: "Other" },
];

export const ASSET_KIND_OPTIONS = [
  { value: "APPLICATION", label: "Application" },
  { value: "AI_MODEL", label: "AI Model" },
  { value: "AI_SERVICE", label: "AI Service" },
  { value: "API", label: "API" },
  { value: "INTERNAL_TOOL", label: "Internal Tool" },
  { value: "OTHER", label: "Other" },
];

export const AI_ASSET_KINDS = ["AI_MODEL", "AI_SERVICE"];

export const SOFTWARE_TYPES = [
  {
    value: "standard",
    label: "Standard Software",
    description:
      "SaaS, business applications, or other software provided by an external vendor.",
  },
  {
    value: "technical",
    label: "System / Technical",
    description:
      "Drivers, utilities, OEM software, and other technical or system components.",
  },
  {
    value: "own-development",
    label: "Own Development",
    description: "Software developed internally by your organization.",
  },
];
